import { STATUS } from "../../utils/constants";

import {
  RESET,
  SET_CURRENT_SEARCH_ID,
  SET_IS_FETCHING_STATUS,
  SET_IS_SEARCH_RESULT_OPEN,
  SET_IS_SEARCHING,
  SET_PRODUCTS,
  SET_SEARCH,
} from "./add-product-to-order-inline.actionTypes";

const initialState = {
  isFetchingStatus: STATUS.IDLE,
  products: [],
  isSearchResultOpen: false,
  search: "",
  currentSearchId: 0,
  isSearching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_FETCHING_STATUS: {
      return {
        ...state,
        isFetchingStatus: action.payload,
      };
    }

    case SET_PRODUCTS: {
      return {
        ...state,
        products: action.payload,
      };
    }

    case SET_IS_SEARCH_RESULT_OPEN: {
      return {
        ...state,
        isSearchResultOpen: action.payload,
      };
    }

    case SET_SEARCH: {
      return {
        ...state,
        search: action.payload,
      };
    }

    case SET_CURRENT_SEARCH_ID: {
      return {
        ...state,
        currentSearchId: action.payload,
      };
    }

    case SET_IS_SEARCHING: {
      return {
        ...state,
        isSearching: action.payload,
      };
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
